import { render, staticRenderFns } from "./CertificateData.vue?vue&type=template&id=2cf1128a&scoped=true"
import script from "./CertificateData.vue?vue&type=script&lang=js"
export * from "./CertificateData.vue?vue&type=script&lang=js"
import style0 from "./CertificateData.vue?vue&type=style&index=0&id=2cf1128a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf1128a",
  null
  
)

export default component.exports